import { Provider } from '@angular/core';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocompleteDefaultOptions } from '@angular/material/autocomplete';
import { MAT_FAB_DEFAULT_OPTIONS, MatFabDefaultOptions } from '@angular/material/button';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipsDefaultOptions } from '@angular/material/chips';
import { MAT_EXPANSION_PANEL_DEFAULT_OPTIONS, MatExpansionPanelDefaultOptions } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MAT_ICON_DEFAULT_OPTIONS, MatIconDefaultOptions } from '@angular/material/icon';
import { MAT_MENU_DEFAULT_OPTIONS, MatMenuDefaultOptions } from '@angular/material/menu';
import { MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorDefaultOptions } from '@angular/material/paginator';
import { MAT_PROGRESS_BAR_DEFAULT_OPTIONS, MatProgressBarDefaultOptions } from '@angular/material/progress-bar';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, MatProgressSpinnerDefaultOptions } from '@angular/material/progress-spinner';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioDefaultOptions } from '@angular/material/radio';
import { MAT_SORT_DEFAULT_OPTIONS, MatSortDefaultOptions } from '@angular/material/sort';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

export function provideMatFormFieldDefaultOptions(): Provider {
  return {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      appearance: 'outline'
    } as MatFormFieldDefaultOptions
  };
}

export function provideMatIconDefaultOptions(): Provider {
  return {
    provide: MAT_ICON_DEFAULT_OPTIONS,
    useValue: {} as MatIconDefaultOptions
  };
}

export function provideMatMenuDefaultOptions(): Provider {
  return {
    provide: MAT_MENU_DEFAULT_OPTIONS,
    useValue: {} as MatMenuDefaultOptions
  };
}

export function provideMatSortDefaultOptions(): Provider {
  return {
    provide: MAT_SORT_DEFAULT_OPTIONS,
    useValue: {} as MatSortDefaultOptions
  };
}

export function provideMatChipsDefaultOptions(): Provider {
  return {
    provide: MAT_CHIPS_DEFAULT_OPTIONS,
    useValue: {} as MatChipsDefaultOptions
  };
}

export function provideMatRadioDefaultOptions(): Provider {
  return {
    provide: MAT_RADIO_DEFAULT_OPTIONS,
    useValue: {} as MatRadioDefaultOptions
  };
}

export function provideMatTooltipDefaultOptions(): Provider {
  return {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: {} as MatTooltipDefaultOptions
  };
}

export function provideMatCheckboxDefaultOptions(): Provider {
  return {
    provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
    useValue: {} as MatCheckboxDefaultOptions
  };
}

export function provideMatPaginatorDefaultOptions(): Provider {
  return {
    provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
    useValue: {} as MatPaginatorDefaultOptions
  };
}

export function provideMatProgressBarDefaultOptions(): Provider {
  return {
    provide: MAT_PROGRESS_BAR_DEFAULT_OPTIONS,
    useValue: {} as MatProgressBarDefaultOptions
  };
}

export function provideMatAutocompleteDefaultOptions(): Provider {
  return {
    provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
    useValue: {} as MatAutocompleteDefaultOptions
  };
}

export function provideMatExpansionPanelDefaultOptions(): Provider {
  return {
    provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
    useValue: {} as MatExpansionPanelDefaultOptions
  };
}

export function provideMatProgressSpinnerDefaultOptions(): Provider {
  return {
    provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
    useValue: {} as MatProgressSpinnerDefaultOptions
  };
}

export function provideMatFabDefaultOptions(): Provider {
  return {
    provide: MAT_FAB_DEFAULT_OPTIONS,
    useValue: {} as MatFabDefaultOptions
  };
}
